import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import {
  LayoutDashboard, Calendar, Users, MessageSquare, Tags, Settings, LogOut,
  Euro, TrendingUp, Clock, FileText, ChevronRight, Loader2, Plus, X, Mail, AlertCircle,
  Image, Trash2, GripVertical, Upload, ChevronLeft, Star, MessageCircle, Check
} from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../components/ui/dialog';
import { Label } from '../components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Liste de TOUTES les photos utilisées sur le site
const ALL_SITE_IMAGES = [
  // Hero images
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/vt2f3ble_IMG_4499.jpg", section: "hero", name: "Entrée principale" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/eef65rl5_06526C50-55D0-4775-AEFE-82A869B5EAF6.PNG", section: "hero", name: "Vue aérienne" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/qn91zz8c_piscinenormont.png", section: "hero", name: "Piscine" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/6edms9f4_jardin.jpg", section: "hero", name: "Jardin" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/42vd3e3r_soiree.png", section: "hero", name: "Villa de nuit" },
  // Section Un lieu d'exception
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/e5d4x9q1_chemine%CC%81e.JPG", section: "about", name: "Salon avec cheminée" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/il5caiec_salonsoir.png", section: "about", name: "Salon de nuit" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/grx00js7_IMG_4465%202.jpg", section: "about", name: "Jardin escalier" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/r12r8a0c_terasse.JPG", section: "about", name: "Terrasse privée" },
  // Galerie villa - Intérieur
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/680xupg6_IMG_4505.jpg", section: "galerie", name: "Salon principal" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/dinkeggh_IMG_4506.jpg", section: "galerie", name: "Cuisine" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/e2q4m8x8_IMG_4507.JPG", section: "galerie", name: "Salle à manger" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/mh7oq1x6_IMG_4508.jpg", section: "galerie", name: "Piano" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/kwi0ehu0_a4b4ad24-786b-4e72-896a-3f479067c828.JPG", section: "galerie", name: "Salle à manger avec lustre" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/c9c8yuzg_c7d19d56-2805-43dd-bad0-d85029e3cbb2.JPG", section: "galerie", name: "Petit salon avec TV" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/spvsyc0r_9d15e18b-ff81-4c11-bc84-399bbda81808.JPG", section: "galerie", name: "Meuble TV et DVD" },
  // Chambres
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/94wmg6lb_IMG_4472.JPG", section: "chambres", name: "Chambre 2 lits" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/cr2qofps_IMG_4511.jpg", section: "chambres", name: "Chambre dorée" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/r03onwk3_IMG_4512.jpg", section: "chambres", name: "Chambre lumineuse" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/0zni7kb2_IMG_4514.jpg", section: "chambres", name: "Chambre cosy" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/q7klr1r6_5f9cbf39-33bd-404d-aca2-5bc239752651.JPG", section: "chambres", name: "Chambre avec terrasse" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/rkbuxeu4_46681970-afdc-466f-81fd-f2db7812b2f0.JPG", section: "chambres", name: "Grande chambre" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/3cfybi8r_b8b78b5e-a635-4100-adcc-dc6747f822a2.JPG", section: "chambres", name: "Chambre avec SDB" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/qchtroef_b6206408-85c7-41b6-ae58-183cf9fd8bab.JPG", section: "chambres", name: "Chambre miroir doré" },
  // Salles de bain
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/rlfk0jpo_IMG_4515.jpg", section: "sdb", name: "Salle de bain 1" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/n4qj56x8_IMG_4516.jpg", section: "sdb", name: "Salle de bain 2" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/93f9wqtx_IMG_4518.jpg", section: "sdb", name: "Salle de bain 3" },
  // Extérieur
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/kqxy7bbh_IMG_4465.jpg", section: "exterieur", name: "Jardin escalier" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/fynmngxb_IMG_4423.jpg", section: "exterieur", name: "Terrasse parc" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/eqj1fuil_cb1bbce0-1cc1-451c-8a45-73445f4ff570.JPG", section: "exterieur", name: "Terrasse avec vue" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/1ve6e0e8_IMG_4424.jpg", section: "exterieur", name: "Parc arboré" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/jsbboy0f_IMG_4425.jpg", section: "exterieur", name: "Piscine vue 2" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/gzsj63fs_IMG_4433.jpg", section: "exterieur", name: "Paillote" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/9ukxucu9_F6E1600D-935C-42C7-AB21-55B3C73F2FD7.PNG", section: "exterieur", name: "Forêt" },
  // Galerie événements
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/nzuij2f6_IMG_1021.JPG", section: "evenements", name: "Événement tentes" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/t1acokwc_D17A63CD-D604-40DF-BE98-01402F746D4F.PNG", section: "evenements", name: "Réception" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/evvw28vd_vuvu.jpg", section: "evenements", name: "Vue aérienne événement" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/f8g8pyox_festif.jpg", section: "evenements", name: "Ambiance festive" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/roev4p7e_DJ.jpg", section: "evenements", name: "DJ en action" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/h3m4iwd9_normont.png", section: "evenements", name: "Soirée vue du ciel" },
];

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { user, logout, loading: authLoading, isAdmin } = useAuth();
  
  const [stats, setStats] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [clients, setClients] = useState([]);
  const [promoCodes, setPromoCodes] = useState([]);
  const [abandonedBookings, setAbandonedBookings] = useState([]);
  const [media, setMedia] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [cancellationRequests, setCancellationRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("dashboard");
  
  // Pagination states
  const [bookingsPage, setBookingsPage] = useState(1);
  const [bookingsTotal, setBookingsTotal] = useState(0);
  const [quotesPage, setQuotesPage] = useState(1);
  const [quotesTotal, setQuotesTotal] = useState(0);
  const [clientsPage, setClientsPage] = useState(1);
  const [clientsTotal, setClientsTotal] = useState(0);
  
  // Promo code dialog
  const [promoDialogOpen, setPromoDialogOpen] = useState(false);
  const [newPromo, setNewPromo] = useState({
    code: '',
    discount_percent: 10,
    valid_from: '',
    valid_until: ''
  });
  
  // Media management
  const [mediaDialogOpen, setMediaDialogOpen] = useState(false);
  const [mediaCategory, setMediaCategory] = useState('all');
  const [newMedia, setNewMedia] = useState({
    url: '',
    alt: '',
    category: 'villa',
    section: 'gallery'
  });
  const [uploadingMedia, setUploadingMedia] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  
  // Reviews management
  const [reviewFilter, setReviewFilter] = useState('all');
  const [responseDialogOpen, setResponseDialogOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [responseText, setResponseText] = useState('');
  
  // Cancellation management
  const [processingCancellation, setProcessingCancellation] = useState(null);
  
  // Quote message expansion
  const [expandedQuoteMessages, setExpandedQuoteMessages] = useState({});
  
  // Site settings
  const [siteSettings, setSiteSettings] = useState({ pool_under_construction: true });
  const [savingSettings, setSavingSettings] = useState(false);
  const [hiddenPhotos, setHiddenPhotos] = useState([]);

  useEffect(() => {
    if (!authLoading) {
      if (!user) {
        navigate('/login');
      } else if (!isAdmin) {
        navigate('/client');
        toast.error('Accès réservé aux administrateurs');
      } else {
        fetchAllData();
      }
    }
  }, [user, authLoading, isAdmin, navigate]);

  const fetchAllData = async () => {
    try {
      const [statsRes, bookingsRes, quotesRes, clientsRes, promosRes, abandonedRes, mediaRes, reviewsRes, settingsRes, hiddenPhotosRes, cancellationsRes] = await Promise.all([
        axios.get(`${API_URL}/api/admin/stats`),
        axios.get(`${API_URL}/api/admin/bookings?page=1&limit=50`),
        axios.get(`${API_URL}/api/admin/quotes?page=1&limit=50`),
        axios.get(`${API_URL}/api/admin/clients?page=1&limit=50`),
        axios.get(`${API_URL}/api/admin/promo-codes`),
        axios.get(`${API_URL}/api/admin/abandoned-bookings`).catch(() => ({ data: [] })),
        axios.get(`${API_URL}/api/admin/media`).catch(() => ({ data: [] })),
        axios.get(`${API_URL}/api/admin/reviews`).catch(() => ({ data: [] })),
        axios.get(`${API_URL}/api/admin/settings`).catch(() => ({ data: { pool_under_construction: true } })),
        axios.get(`${API_URL}/api/admin/hidden-photos`).catch(() => ({ data: [] })),
        axios.get(`${API_URL}/api/admin/cancellation-requests`).catch(() => ({ data: { items: [] } }))
      ]);
      setStats(statsRes.data);
      setBookings(bookingsRes.data.items || bookingsRes.data);
      setBookingsTotal(bookingsRes.data.total || bookingsRes.data.length);
      setQuotes(quotesRes.data.items || quotesRes.data);
      setQuotesTotal(quotesRes.data.total || quotesRes.data.length);
      setClients(clientsRes.data.items || clientsRes.data);
      setClientsTotal(clientsRes.data.total || clientsRes.data.length);
      setPromoCodes(promosRes.data);
      setAbandonedBookings(abandonedRes.data);
      setMedia(mediaRes.data);
      setReviews(reviewsRes.data);
      setSiteSettings(settingsRes.data);
      setHiddenPhotos(hiddenPhotosRes.data);
      setCancellationRequests(cancellationsRes.data.items || []);
    } catch (error) {
      console.error('Error fetching admin data:', error);
      toast.error('Erreur lors du chargement des données');
    } finally {
      setLoading(false);
    }
  };

  const sendReminder = async (bookingId) => {
    try {
      await axios.post(`${API_URL}/api/admin/send-reminder/${bookingId}`, {});
      toast.success('Email de relance envoyé !');
    } catch (error) {
      toast.error('Erreur lors de l\'envoi');
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const handleCreatePromoCode = async () => {
    try {
      await axios.post(`${API_URL}/api/admin/promo-codes`, newPromo);
      toast.success('Code promo créé');
      setPromoDialogOpen(false);
      fetchAllData();
    } catch (error) {
      toast.error('Erreur lors de la création');
    }
  };

  const updateQuoteStatus = async (quoteId, status) => {
    try {
      await axios.put(`${API_URL}/api/admin/quotes/${quoteId}/status?status=${status}`, {});
      toast.success('Statut mis à jour');
      fetchAllData();
    } catch (error) {
      toast.error('Erreur lors de la mise à jour');
    }
  };

  // Approve cancellation with Stripe refund
  const approveCancellation = async (bookingId) => {
    setProcessingCancellation(bookingId);
    try {
      const response = await axios.post(`${API_URL}/api/admin/bookings/${bookingId}/approve-cancellation`);
      const data = response.data;
      
      if (data.refund_processed) {
        toast.success(`Annulation approuvée ! Remboursement de ${data.refund_amount}€ effectué via Stripe.`);
      } else if (data.refund_amount === 0) {
        toast.success('Annulation approuvée. Aucun remboursement (moins de 7 jours avant l\'arrivée).');
      } else if (data.refund_error) {
        toast.warning(`Annulation approuvée. Remboursement Stripe en erreur: ${data.refund_error}. Veuillez effectuer le remboursement manuellement.`);
      } else {
        toast.success('Annulation approuvée.');
      }
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'approbation');
    } finally {
      setProcessingCancellation(null);
    }
  };

  // Reject cancellation - booking stays confirmed
  const rejectCancellation = async (bookingId) => {
    setProcessingCancellation(bookingId);
    try {
      await axios.post(`${API_URL}/api/admin/bookings/${bookingId}/reject-cancellation`);
      toast.success('Demande d\'annulation refusée. La réservation reste confirmée.');
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors du refus');
    } finally {
      setProcessingCancellation(null);
    }
  };
  
  // Save site settings
  const saveSiteSettings = async () => {
    setSavingSettings(true);
    try {
      await axios.put(`${API_URL}/api/admin/settings`, siteSettings);
      toast.success('Paramètres sauvegardés');
    } catch (error) {
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setSavingSettings(false);
    }
  };
  
  // Hide a site photo (store in backend)
  const handleHideSitePhoto = async (photoUrl) => {
    try {
      await axios.post(`${API_URL}/api/admin/hide-photo`, { url: photoUrl });
      setHiddenPhotos(prev => [...prev, photoUrl]);
      toast.success('Photo masquée du site');
    } catch (error) {
      toast.error('Erreur lors du masquage');
    }
  };
  
  // Media management functions
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileSelect(e.dataTransfer.files[0]);
    }
  };

  const handleFileSelect = (file) => {
    if (!file.type.startsWith('image/')) {
      toast.error('Veuillez sélectionner une image (JPG, PNG, WEBP, GIF)');
      return;
    }
    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
    // Auto-fill alt with filename without extension
    const altText = file.name.replace(/\.[^/.]+$/, "").replace(/_/g, " ").replace(/-/g, " ");
    setNewMedia(prev => ({ ...prev, alt: altText }));
  };

  const handleUploadMedia = async () => {
    if (!selectedFile) {
      toast.error('Veuillez sélectionner une image');
      return;
    }
    if (!newMedia.alt) {
      toast.error('Veuillez ajouter une description');
      return;
    }
    
    setUploadingMedia(true);
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('alt', newMedia.alt);
    formData.append('category', newMedia.category);
    formData.append('section', newMedia.section);
    
    try {
      await axios.post(`${API_URL}/api/admin/media/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Image uploadée avec succès !');
      setMediaDialogOpen(false);
      resetMediaForm();
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'upload');
    } finally {
      setUploadingMedia(false);
    }
  };
  
  const resetMediaForm = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
    setNewMedia({ url: '', alt: '', category: 'villa', section: 'gallery' });
  };
  
  const handleDeleteMedia = async (mediaId) => {
    if (!window.confirm('Supprimer cette image ?')) return;
    try {
      await axios.delete(`${API_URL}/api/admin/media/${mediaId}/file`);
      toast.success('Image supprimée');
      fetchAllData();
    } catch (error) {
      toast.error('Erreur lors de la suppression');
    }
  };
  
  // Reviews management functions
  const handleApproveReview = async (reviewId) => {
    try {
      await axios.put(`${API_URL}/api/admin/reviews/${reviewId}/approve`, {});
      toast.success('Avis approuvé');
      fetchAllData();
    } catch (error) {
      toast.error('Erreur lors de l\'approbation');
    }
  };
  
  const handleDeleteReview = async (reviewId) => {
    if (!window.confirm('Supprimer cet avis ?')) return;
    try {
      await axios.delete(`${API_URL}/api/admin/reviews/${reviewId}`);
      toast.success('Avis supprimé');
      fetchAllData();
    } catch (error) {
      toast.error('Erreur lors de la suppression');
    }
  };
  
  const handleRespondToReview = async () => {
    if (!responseText.trim()) {
      toast.error('Veuillez entrer une réponse');
      return;
    }
    try {
      await axios.put(
        `${API_URL}/api/admin/reviews/${selectedReview.id}/respond?response=${encodeURIComponent(responseText)}`, 
        {}, 
        
      );
      toast.success('Réponse ajoutée');
      setResponseDialogOpen(false);
      setSelectedReview(null);
      setResponseText('');
      fetchAllData();
    } catch (error) {
      toast.error('Erreur lors de l\'ajout de la réponse');
    }
  };
  
  const filteredReviews = reviewFilter === 'all' 
    ? reviews 
    : reviewFilter === 'pending' 
      ? reviews.filter(r => !r.approved)
      : reviews.filter(r => r.approved);
  
  const pendingReviewsCount = reviews.filter(r => !r.approved).length;
  
  // Combine site images with uploaded images (excluding hidden ones)
  const allMediaImages = [
    ...ALL_SITE_IMAGES
      .filter(img => !hiddenPhotos.includes(img.url))
      .map((img, index) => ({
        id: `site-${index}`,
        url: img.url,
        alt: img.name,
        category: img.section === 'hero' ? 'villa' 
          : img.section === 'about' ? 'villa'
          : img.section === 'galerie' ? 'villa'
          : img.section === 'chambres' ? 'bedroom'
          : img.section === 'sdb' ? 'bathroom'
          : img.section === 'exterieur' ? 'exterior'
          : img.section === 'evenements' ? 'event'
          : 'villa',
        isHardcoded: true
      })),
    ...media.map(m => ({ ...m, isHardcoded: false }))
  ];
  
  const filteredMedia = mediaCategory === 'all' 
    ? allMediaImages 
    : allMediaImages.filter(m => m.category === mediaCategory);
  
  const mediaCategories = [
    { value: 'all', label: 'Toutes' },
    { value: 'villa', label: 'Villa' },
    { value: 'bedroom', label: 'Chambres' },
    { value: 'bathroom', label: 'Salles de bain' },
    { value: 'exterior', label: 'Extérieur' },
    { value: 'event', label: 'Événements' }
  ];

  const getStatusBadge = (status) => {
    const styles = {
      pending: 'bg-yellow-100 text-yellow-800',
      confirmed: 'bg-green-100 text-green-800',
      cancelled: 'bg-red-100 text-red-800',
      contacted: 'bg-blue-100 text-blue-800',
      completed: 'bg-gray-100 text-gray-800',
      cancellation_requested: 'bg-orange-100 text-orange-800'
    };
    const labels = {
      pending: 'En attente de paiement',
      confirmed: 'Confirmée (payée)',
      cancelled: 'Annulée',
      contacted: 'Contacté',
      completed: 'Terminée',
      cancellation_requested: 'Annulation demandée'
    };
    return <span className={`px-2 py-1 text-xs font-medium ${styles[status] || styles.pending}`}>{labels[status] || status}</span>;
  };

  if (authLoading || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="loading">
        <Loader2 className="w-8 h-8 animate-spin text-[#C5A059]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="admin-dashboard">
      {/* Sidebar */}
      <div className="admin-sidebar">
        <div className="p-6 border-b border-white/10">
          <h1 className="text-xl font-['Playfair_Display']">Domaine du Normont</h1>
          <p className="text-sm text-white/50 font-['Outfit']">Administration</p>
        </div>
        <nav className="py-4">
          <button
            onClick={() => setActiveTab("dashboard")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "dashboard" ? 'active' : ''}`}
            data-testid="nav-dashboard"
          >
            <LayoutDashboard className="w-5 h-5" />
            Tableau de bord
          </button>
          <button
            onClick={() => setActiveTab("bookings")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "bookings" ? 'active' : ''}`}
            data-testid="nav-admin-bookings"
          >
            <Calendar className="w-5 h-5" />
            Réservations
          </button>
          <button
            onClick={() => setActiveTab("cancellations")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "cancellations" ? 'active' : ''}`}
            data-testid="nav-cancellations"
          >
            <X className="w-5 h-5" />
            Annulations
            {cancellationRequests.length > 0 && (
              <span className="ml-auto bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                {cancellationRequests.length}
              </span>
            )}
          </button>
          <button
            onClick={() => setActiveTab("abandoned")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "abandoned" ? 'active' : ''}`}
            data-testid="nav-abandoned"
          >
            <AlertCircle className="w-5 h-5" />
            Relances
            {abandonedBookings.length > 0 && (
              <span className="ml-auto bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                {abandonedBookings.length}
              </span>
            )}
          </button>
          <button
            onClick={() => setActiveTab("quotes")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "quotes" ? 'active' : ''}`}
            data-testid="nav-quotes"
          >
            <FileText className="w-5 h-5" />
            Demandes de devis
          </button>
          <button
            onClick={() => setActiveTab("clients")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "clients" ? 'active' : ''}`}
            data-testid="nav-clients"
          >
            <Users className="w-5 h-5" />
            Clients
          </button>
          <button
            onClick={() => setActiveTab("promos")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "promos" ? 'active' : ''}`}
            data-testid="nav-promos"
          >
            <Tags className="w-5 h-5" />
            Codes promo
          </button>
          <button
            onClick={() => setActiveTab("media")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "media" ? 'active' : ''}`}
            data-testid="nav-media"
          >
            <Image className="w-5 h-5" />
            Médias
            <span className="ml-auto text-xs text-white/50">{media.length}</span>
          </button>
          <button
            onClick={() => setActiveTab("reviews")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "reviews" ? 'active' : ''}`}
            data-testid="nav-reviews"
          >
            <Star className="w-5 h-5" />
            Avis clients
            {pendingReviewsCount > 0 && (
              <span className="ml-auto bg-orange-500 text-white text-xs px-2 py-0.5 rounded-full">
                {pendingReviewsCount}
              </span>
            )}
          </button>
          <button
            onClick={() => setActiveTab("settings")}
            className={`admin-sidebar-link w-full text-left ${activeTab === "settings" ? 'active' : ''}`}
            data-testid="nav-settings"
          >
            <Settings className="w-5 h-5" />
            Paramètres
          </button>
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/10">
          <button
            onClick={handleLogout}
            className="admin-sidebar-link w-full justify-center text-red-400 hover:text-red-300"
            data-testid="admin-logout"
          >
            <LogOut className="w-5 h-5" />
            Déconnexion
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="ml-64 p-8">
        {/* Dashboard Tab */}
        {activeTab === "dashboard" && (
          <div data-testid="dashboard-content">
            <h2 className="text-2xl font-['Playfair_Display'] mb-8">Tableau de bord</h2>
            
            {/* Stats Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              <div className="stats-card" data-testid="stat-revenue">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-green-100 flex items-center justify-center">
                    <Euro className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <p className="stats-card-label">Chiffre d'affaires</p>
                    <p className="stats-card-value">{stats?.total_revenue?.toLocaleString() || 0}€</p>
                  </div>
                </div>
              </div>
              <div className="stats-card" data-testid="stat-bookings">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-blue-100 flex items-center justify-center">
                    <Calendar className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <p className="stats-card-label">Réservations</p>
                    <p className="stats-card-value">{stats?.confirmed_bookings || 0}</p>
                  </div>
                </div>
              </div>
              <div className="stats-card" data-testid="stat-quotes">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-yellow-100 flex items-center justify-center">
                    <FileText className="w-6 h-6 text-yellow-600" />
                  </div>
                  <div>
                    <p className="stats-card-label">Devis en attente</p>
                    <p className="stats-card-value">{stats?.pending_quotes || 0}</p>
                  </div>
                </div>
              </div>
              <div className="stats-card" data-testid="stat-clients">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-purple-100 flex items-center justify-center">
                    <Users className="w-6 h-6 text-purple-600" />
                  </div>
                  <div>
                    <p className="stats-card-label">Clients</p>
                    <p className="stats-card-value">{stats?.total_clients || 0}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Recent Bookings */}
            <div className="bg-white border border-[#E5E5E5]">
              <div className="p-6 border-b border-[#E5E5E5] flex justify-between items-center">
                <h3 className="text-lg font-['Playfair_Display']">Dernières réservations</h3>
                <Button variant="ghost" onClick={() => setActiveTab("bookings")} className="text-[#C5A059]">
                  Voir tout <ChevronRight className="w-4 h-4 ml-1" />
                </Button>
              </div>
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Dates</th>
                    <th>Invités</th>
                    <th>Montant</th>
                    <th>Statut</th>
                  </tr>
                </thead>
                <tbody>
                  {stats?.recent_bookings?.slice(0, 5).map((booking, index) => (
                    <tr key={index}>
                      <td className="font-['Outfit']">{booking.user_name || booking.user_email}</td>
                      <td className="font-['Outfit']">{format(new Date(booking.check_in), 'd MMM', { locale: fr })} - {format(new Date(booking.check_out), 'd MMM', { locale: fr })}</td>
                      <td className="font-['Outfit']">{booking.guests}</td>
                      <td className="font-['Outfit'] font-semibold">{booking.total_price}€</td>
                      <td>{getStatusBadge(booking.status)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Bookings Tab */}
        {activeTab === "bookings" && (
          <div data-testid="bookings-content">
            <h2 className="text-2xl font-['Playfair_Display'] mb-8">Toutes les réservations</h2>
            <div className="bg-white border border-[#E5E5E5]">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Email</th>
                    <th>Arrivée</th>
                    <th>Départ</th>
                    <th>Nuits</th>
                    <th>Invités</th>
                    <th>Montant</th>
                    <th>Statut</th>
                  </tr>
                </thead>
                <tbody>
                  {bookings.map((booking, index) => (
                    <tr key={index}>
                      <td className="font-['Outfit']">{booking.user_name || '-'}</td>
                      <td className="font-['Outfit'] text-sm">{booking.user_email}</td>
                      <td className="font-['Outfit']">{format(new Date(booking.check_in), 'd MMM yyyy', { locale: fr })}</td>
                      <td className="font-['Outfit']">{format(new Date(booking.check_out), 'd MMM yyyy', { locale: fr })}</td>
                      <td className="font-['Outfit']">{booking.nights}</td>
                      <td className="font-['Outfit']">{booking.guests}</td>
                      <td className="font-['Outfit'] font-semibold">{booking.total_price}€</td>
                      <td>{getStatusBadge(booking.status)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Quotes Tab */}
        {activeTab === "quotes" && (
          <div data-testid="quotes-content">
            <h2 className="text-2xl font-['Playfair_Display'] mb-8">Demandes de devis</h2>
            
            {quotes.length === 0 ? (
              <div className="bg-white border border-[#E5E5E5] p-12 text-center">
                <p className="text-[#666666] font-['Outfit']">Aucune demande de devis</p>
              </div>
            ) : (
              <div className="space-y-4">
                {quotes.map((quote, index) => (
                  <div key={index} className="bg-white border border-[#E5E5E5] p-6">
                    <div className="flex justify-between items-start mb-4">
                      <div>
                        <div className="flex items-center gap-3 mb-2">
                          <span className="text-lg font-['Playfair_Display'] capitalize">
                            {quote.event_type.replace('_', ' ')}
                          </span>
                          {getStatusBadge(quote.status)}
                        </div>
                        <p className="text-sm text-[#666666] font-['Outfit']">
                          Demande reçue le {quote.created_at ? format(new Date(quote.created_at), 'd MMMM yyyy à HH:mm', { locale: fr }) : '-'}
                        </p>
                      </div>
                      <select 
                        className="text-sm border border-[#E5E5E5] p-2 rounded"
                        value={quote.status}
                        onChange={(e) => updateQuoteStatus(quote.id, e.target.value)}
                      >
                        <option value="pending">En attente</option>
                        <option value="contacted">Contacté</option>
                        <option value="confirmed">Confirmé</option>
                        <option value="cancelled">Annulé</option>
                      </select>
                    </div>
                    
                    <div className="grid md:grid-cols-4 gap-4 mb-4">
                      <div>
                        <p className="text-xs text-[#666] font-['Outfit']">Client</p>
                        <p className="font-['Outfit'] font-medium">{quote.name}</p>
                        <p className="text-sm text-[#666]">{quote.email}</p>
                        <p className="text-sm text-[#666]">{quote.phone}</p>
                      </div>
                      <div>
                        <p className="text-xs text-[#666] font-['Outfit']">Dates souhaitées</p>
                        <p className="font-['Outfit'] font-medium">
                          {format(new Date(quote.check_in), 'd MMM yyyy', { locale: fr })} - {format(new Date(quote.check_out), 'd MMM yyyy', { locale: fr })}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-[#666] font-['Outfit']">Nombre d'invités</p>
                        <p className="font-['Outfit'] font-medium">{quote.guests} personnes</p>
                      </div>
                      <div>
                        <p className="text-xs text-[#666] font-['Outfit']">Actions rapides</p>
                        <div className="flex gap-2 mt-1">
                          <a 
                            href={`mailto:${quote.email}?subject=Votre demande de devis - ${quote.event_type.replace('_', ' ')} - Domaine du Normont`}
                            className="text-xs text-[#C5A059] hover:underline"
                          >
                            Envoyer un email
                          </a>
                          <span className="text-[#E5E5E5]">|</span>
                          <a 
                            href={`tel:${quote.phone}`}
                            className="text-xs text-[#C5A059] hover:underline"
                          >
                            Appeler
                          </a>
                        </div>
                      </div>
                    </div>
                    
                    {/* Message du client */}
                    {quote.message && (
                      <div className="mt-4 pt-4 border-t border-[#E5E5E5]">
                        <p className="text-xs text-[#666] font-['Outfit'] mb-2">Message du client :</p>
                        <div className="bg-[#FAFAFA] p-3 rounded">
                          <p className="font-['Outfit'] text-sm text-[#333] whitespace-pre-wrap">
                            {expandedQuoteMessages[index] || quote.message.length <= 300
                              ? quote.message
                              : `${quote.message.substring(0, 300)}...`
                            }
                          </p>
                          {quote.message.length > 300 && (
                            <button
                              onClick={() => setExpandedQuoteMessages(prev => ({
                                ...prev,
                                [index]: !prev[index]
                              }))}
                              className="text-[#C5A059] text-sm mt-2 hover:underline font-['Outfit']"
                            >
                              {expandedQuoteMessages[index] ? 'Réduire' : 'Lire la suite'}
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Clients Tab */}
        {activeTab === "clients" && (
          <div data-testid="clients-content">
            <h2 className="text-2xl font-['Playfair_Display'] mb-8">Clients</h2>
            <div className="bg-white border border-[#E5E5E5]">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Email</th>
                    <th>Téléphone</th>
                    <th>Inscrit le</th>
                  </tr>
                </thead>
                <tbody>
                  {clients.map((client, index) => (
                    <tr key={index}>
                      <td className="font-['Outfit']">{client.name || '-'}</td>
                      <td className="font-['Outfit']">{client.email}</td>
                      <td className="font-['Outfit']">{client.phone || '-'}</td>
                      <td className="font-['Outfit']">{client.created_at ? format(new Date(client.created_at), 'd MMM yyyy', { locale: fr }) : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Promo Codes Tab */}
        {activeTab === "promos" && (
          <div data-testid="promos-content">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-['Playfair_Display']">Codes promo</h2>
              <Button 
                className="bg-[#C5A059] hover:bg-[#A6864A] text-white"
                onClick={() => setPromoDialogOpen(true)}
                data-testid="add-promo-btn"
              >
                <Plus className="w-4 h-4 mr-2" /> Nouveau code
              </Button>
            </div>
            <div className="bg-white border border-[#E5E5E5]">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Réduction</th>
                    <th>Valide du</th>
                    <th>Valide jusqu'au</th>
                    <th>Statut</th>
                  </tr>
                </thead>
                <tbody>
                  {promoCodes.map((promo, index) => (
                    <tr key={index}>
                      <td className="font-['Outfit'] font-mono font-bold">{promo.code}</td>
                      <td className="font-['Outfit']">{promo.discount_percent}%</td>
                      <td className="font-['Outfit']">{format(new Date(promo.valid_from), 'd MMM yyyy', { locale: fr })}</td>
                      <td className="font-['Outfit']">{format(new Date(promo.valid_until), 'd MMM yyyy', { locale: fr })}</td>
                      <td>{promo.active ? <span className="text-green-600">Actif</span> : <span className="text-red-600">Inactif</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Cancellation Requests Tab */}
        {activeTab === "cancellations" && (
          <div data-testid="cancellations-content">
            <h2 className="text-2xl font-['Playfair_Display'] mb-8">Demandes d'annulation</h2>
            <p className="text-[#666666] font-['Outfit'] mb-6">
              Gérez les demandes d'annulation de vos clients. Approuvez pour effectuer le remboursement via Stripe selon la politique d'annulation.
            </p>
            
            {/* Policy reminder */}
            <div className="bg-amber-50 border border-amber-200 p-4 rounded mb-6">
              <p className="font-semibold text-amber-800 mb-2">Politique d'annulation :</p>
              <ul className="text-sm text-amber-700 space-y-1">
                <li>• Plus de 14 jours avant l'arrivée : <strong>100% remboursé</strong></li>
                <li>• Entre 7 et 14 jours avant l'arrivée : <strong>50% remboursé</strong></li>
                <li>• Moins de 7 jours avant l'arrivée : <strong>Non remboursable</strong></li>
              </ul>
            </div>
            
            {cancellationRequests.length === 0 ? (
              <div className="bg-white border border-[#E5E5E5] p-12 text-center">
                <Check className="w-12 h-12 text-green-500 mx-auto mb-4" />
                <p className="text-[#666666] font-['Outfit']">Aucune demande d'annulation en attente</p>
                <p className="text-sm text-[#999] font-['Outfit'] mt-2">Toutes les demandes ont été traitées.</p>
              </div>
            ) : (
              <div className="space-y-4">
                {cancellationRequests.map((booking, index) => (
                  <div key={booking.id || index} className="bg-white border border-[#E5E5E5] p-6">
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-3">
                          <span className="px-3 py-1 bg-orange-100 text-orange-800 text-sm rounded-full font-medium">
                            Annulation demandée
                          </span>
                          <span className="text-sm text-[#666]">
                            Demandé le {booking.cancellation_requested_at ? format(new Date(booking.cancellation_requested_at), 'd MMM yyyy à HH:mm', { locale: fr }) : '-'}
                          </span>
                        </div>
                        
                        <div className="grid md:grid-cols-4 gap-4 mb-4">
                          <div>
                            <p className="text-xs text-[#666] font-['Outfit']">Client</p>
                            <p className="font-['Outfit'] font-medium">{booking.user_name || booking.user_email}</p>
                            <p className="text-sm text-[#666]">{booking.user_email}</p>
                          </div>
                          <div>
                            <p className="text-xs text-[#666] font-['Outfit']">Dates du séjour</p>
                            <p className="font-['Outfit'] font-medium">{booking.check_in} → {booking.check_out}</p>
                            <p className="text-sm text-[#666]">{booking.nights} nuits, {booking.guests} pers.</p>
                          </div>
                          <div>
                            <p className="text-xs text-[#666] font-['Outfit']">Montant total payé</p>
                            <p className="font-['Outfit'] font-semibold text-lg">{booking.total_price}€</p>
                          </div>
                          <div>
                            <p className="text-xs text-[#666] font-['Outfit']">Remboursement calculé</p>
                            <p className={`font-['Outfit'] font-semibold text-lg ${booking.refund_percent > 0 ? 'text-green-600' : 'text-red-600'}`}>
                              {booking.refund_amount}€ ({booking.refund_percent}%)
                            </p>
                            <p className="text-xs text-[#666]">
                              {booking.refund_percent === 100 && "Plus de 14 jours"}
                              {booking.refund_percent === 50 && "Entre 7 et 14 jours"}
                              {booking.refund_percent === 0 && "Moins de 7 jours"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex gap-3 pt-4 border-t border-[#E5E5E5]">
                      <Button
                        className="bg-green-600 hover:bg-green-700 text-white"
                        onClick={() => approveCancellation(booking.id)}
                        disabled={processingCancellation === booking.id}
                        data-testid={`approve-cancel-${index}`}
                      >
                        {processingCancellation === booking.id ? (
                          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        ) : (
                          <Check className="w-4 h-4 mr-2" />
                        )}
                        Approuver & Rembourser {booking.refund_amount}€
                      </Button>
                      <Button
                        variant="outline"
                        className="border-red-300 text-red-600 hover:bg-red-50"
                        onClick={() => rejectCancellation(booking.id)}
                        disabled={processingCancellation === booking.id}
                        data-testid={`reject-cancel-${index}`}
                      >
                        <X className="w-4 h-4 mr-2" />
                        Refuser (garder la réservation)
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Abandoned Bookings / Relances Tab */}
        {activeTab === "abandoned" && (
          <div data-testid="abandoned-content">
            <h2 className="text-2xl font-['Playfair_Display'] mb-8">Réservations abandonnées</h2>
            <p className="text-[#666666] font-['Outfit'] mb-6">
              Réservations commencées mais non finalisées (en attente depuis plus d'1 heure). 
              Envoyez un email de relance pour récupérer ces clients potentiels.
            </p>
            {abandonedBookings.length === 0 ? (
              <div className="bg-white border border-[#E5E5E5] p-12 text-center">
                <AlertCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
                <p className="text-[#666666] font-['Outfit']">Aucune réservation abandonnée !</p>
                <p className="text-sm text-[#999] font-['Outfit'] mt-2">Toutes les réservations ont été finalisées.</p>
              </div>
            ) : (
              <div className="bg-white border border-[#E5E5E5]">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Dates</th>
                      <th>Invités</th>
                      <th>Montant</th>
                      <th>Abandonné depuis</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {abandonedBookings.map((booking, index) => (
                      <tr key={index}>
                        <td className="font-['Outfit']">{booking.user_email || '-'}</td>
                        <td className="font-['Outfit']">{booking.check_in} - {booking.check_out}</td>
                        <td className="font-['Outfit']">{booking.guests}</td>
                        <td className="font-['Outfit'] font-semibold">{booking.total_price}€</td>
                        <td className="font-['Outfit'] text-sm text-[#666]">
                          {booking.created_at ? format(new Date(booking.created_at), 'd MMM HH:mm', { locale: fr }) : '-'}
                        </td>
                        <td>
                          <Button 
                            size="sm"
                            className="bg-[#C5A059] hover:bg-[#A6864A] text-white"
                            onClick={() => sendReminder(booking.id)}
                            data-testid={`send-reminder-${index}`}
                          >
                            <Mail className="w-4 h-4 mr-1" />
                            Relancer
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Media Management Tab */}
        {activeTab === "media" && (
          <div data-testid="media-content">
            <div className="flex justify-between items-center mb-8">
              <div>
                <h2 className="text-2xl font-['Playfair_Display']">Gestion des médias</h2>
                <p className="text-[#666666] font-['Outfit'] text-sm mt-1">
                  Gérez les images affichées sur le site. Ajoutez des URLs d'images hébergées.
                </p>
              </div>
              <Button 
                className="bg-[#C5A059] hover:bg-[#A6864A] text-white"
                onClick={() => setMediaDialogOpen(true)}
                data-testid="add-media-btn"
              >
                <Plus className="w-4 h-4 mr-2" /> Ajouter une image
              </Button>
            </div>
            
            {/* Category Filter */}
            <div className="flex gap-2 mb-6">
              {mediaCategories.map((cat) => (
                <button
                  key={cat.value}
                  onClick={() => setMediaCategory(cat.value)}
                  className={`px-4 py-2 text-sm font-['Outfit'] border transition-colors ${
                    mediaCategory === cat.value 
                      ? 'bg-[#0A0A0A] text-white border-[#0A0A0A]' 
                      : 'bg-white text-[#666666] border-[#E5E5E5] hover:border-[#0A0A0A]'
                  }`}
                  data-testid={`media-filter-${cat.value}`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
            
            {filteredMedia.length === 0 ? (
              <div className="bg-white border border-[#E5E5E5] p-12 text-center">
                <Image className="w-12 h-12 text-[#E5E5E5] mx-auto mb-4" />
                <p className="text-[#666666] font-['Outfit']">Aucune image dans cette catégorie</p>
                <p className="text-sm text-[#999] font-['Outfit'] mt-2">Cliquez sur "Ajouter une image" pour commencer.</p>
              </div>
            ) : (
              <>
                <p className="text-sm text-[#666666] font-['Outfit'] mb-4">{filteredMedia.length} image(s) au total</p>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  {filteredMedia.map((item, index) => (
                    <div key={item.id || index} className="bg-white border border-[#E5E5E5] overflow-hidden group" data-testid={`media-item-${index}`}>
                      <div className="aspect-video relative">
                        <img 
                          src={item.url} 
                          alt={item.alt}
                          className="w-full h-full object-cover"
                          onError={(e) => { e.target.src = 'https://via.placeholder.com/400x300?text=Image+Error'; }}
                        />
                        {/* Delete button for ALL photos */}
                        <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                          <Button 
                            size="sm" 
                            variant="destructive"
                            onClick={() => {
                              if (item.isHardcoded) {
                                // For hardcoded photos, we'll hide them by adding to a "hidden" list
                                handleHideSitePhoto(item.url);
                              } else {
                                handleDeleteMedia(item.id);
                              }
                            }}
                            data-testid={`delete-media-${index}`}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                        {item.isHardcoded && (
                          <div className="absolute top-2 left-2 bg-[#0A0A0A]/70 text-white text-xs px-2 py-1 rounded font-['Outfit']">
                            Photo du site
                          </div>
                        )}
                      </div>
                      <div className="p-3">
                        <p className="text-sm font-['Outfit'] truncate">{item.alt}</p>
                        <p className="text-xs text-[#C5A059] font-['Outfit'] capitalize">{item.category}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        {/* Reviews Management Tab */}
        {activeTab === "reviews" && (
          <div data-testid="reviews-content">
            <div className="flex justify-between items-center mb-8">
              <div>
                <h2 className="text-2xl font-['Playfair_Display']">Gestion des avis</h2>
                <p className="text-[#666666] font-['Outfit'] text-sm mt-1">
                  {reviews.length} avis au total • {pendingReviewsCount} en attente d'approbation
                </p>
              </div>
            </div>
            
            {/* Filter tabs */}
            <div className="flex gap-2 mb-6">
              {[
                { value: 'all', label: 'Tous' },
                { value: 'pending', label: `En attente (${pendingReviewsCount})` },
                { value: 'approved', label: 'Approuvés' }
              ].map((filter) => (
                <button
                  key={filter.value}
                  onClick={() => setReviewFilter(filter.value)}
                  className={`px-4 py-2 text-sm font-['Outfit'] border transition-colors ${
                    reviewFilter === filter.value 
                      ? 'bg-[#0A0A0A] text-white border-[#0A0A0A]' 
                      : 'bg-white text-[#666666] border-[#E5E5E5] hover:border-[#0A0A0A]'
                  }`}
                >
                  {filter.label}
                </button>
              ))}
            </div>
            
            {filteredReviews.length === 0 ? (
              <div className="bg-white border border-[#E5E5E5] p-12 text-center">
                <Star className="w-12 h-12 text-[#E5E5E5] mx-auto mb-4" />
                <p className="text-[#666666] font-['Outfit']">Aucun avis dans cette catégorie</p>
              </div>
            ) : (
              <div className="space-y-4">
                {filteredReviews.map((review, index) => (
                  <div 
                    key={review.id || index} 
                    className={`bg-white border p-6 ${!review.approved ? 'border-orange-300 bg-orange-50' : 'border-[#E5E5E5]'}`}
                    data-testid={`admin-review-${index}`}
                  >
                    <div className="flex justify-between items-start mb-4">
                      <div>
                        <div className="flex items-center gap-2 mb-2">
                          <div className="flex">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <Star 
                                key={star} 
                                className={`w-4 h-4 ${star <= (review.rating || 5) ? 'fill-[#C5A059] text-[#C5A059]' : 'text-gray-300'}`} 
                              />
                            ))}
                          </div>
                          {!review.approved && (
                            <span className="text-xs bg-orange-200 text-orange-700 px-2 py-1 rounded">
                              En attente
                            </span>
                          )}
                          {review.source && (
                            <span className="text-xs text-[#666] bg-gray-100 px-2 py-1 rounded">
                              {review.source === 'airbnb' && 'Airbnb'}
                              {review.source === 'abritel' && 'Abritel'}
                              {review.source === 'client' && 'Client'}
                              {review.source === 'admin' && 'Manuel'}
                            </span>
                          )}
                        </div>
                        <p className="font-semibold font-['Outfit']">{review.author}</p>
                        {review.user_email && (
                          <p className="text-sm text-[#999] font-['Outfit']">{review.user_email}</p>
                        )}
                      </div>
                      <div className="flex gap-2">
                        {!review.approved && (
                          <Button 
                            size="sm"
                            className="bg-green-600 hover:bg-green-700 text-white"
                            onClick={() => handleApproveReview(review.id)}
                          >
                            <Check className="w-4 h-4 mr-1" />
                            Approuver
                          </Button>
                        )}
                        <Button 
                          size="sm"
                          variant="outline"
                          onClick={() => { setSelectedReview(review); setResponseDialogOpen(true); }}
                        >
                          <MessageCircle className="w-4 h-4 mr-1" />
                          Répondre
                        </Button>
                        <Button 
                          size="sm"
                          variant="destructive"
                          onClick={() => handleDeleteReview(review.id)}
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                    
                    <p className="text-[#666666] font-['Outfit'] mb-4">"{review.comment}"</p>
                    
                    {review.admin_response && (
                      <div className="bg-gray-50 p-4 border-l-4 border-[#C5A059]">
                        <p className="text-sm font-semibold text-[#0A0A0A] font-['Outfit'] mb-1">
                          Votre réponse :
                        </p>
                        <p className="text-sm text-[#666] font-['Outfit']">{review.admin_response}</p>
                      </div>
                    )}
                    
                    <p className="text-xs text-[#999] font-['Outfit'] mt-4">
                      {review.created_at && format(new Date(review.created_at), 'd MMMM yyyy', { locale: fr })}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Settings Tab */}
        {activeTab === "settings" && (
          <div data-testid="settings-content">
            <h2 className="text-2xl font-['Playfair_Display'] mb-8">Paramètres du site</h2>
            
            <div className="bg-white border border-[#E5E5E5] p-8 max-w-2xl">
              <h3 className="text-lg font-['Playfair_Display'] mb-6">Notifications aux clients</h3>
              
              <div className="space-y-6">
                {/* Pool notice setting */}
                <div className="flex items-center justify-between p-4 bg-[#FAFAFA] rounded border">
                  <div>
                    <p className="font-semibold font-['Outfit']">Piscine en travaux</p>
                    <p className="text-sm text-[#666666] font-['Outfit']">
                      Affiche une notice sur les pages de réservation et de devis pour prévenir les clients
                    </p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={siteSettings.pool_under_construction}
                      onChange={(e) => setSiteSettings({ ...siteSettings, pool_under_construction: e.target.checked })}
                      className="sr-only peer"
                      data-testid="pool-notice-toggle"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#C5A059]"></div>
                  </label>
                </div>
                
                {/* Preview of the notice */}
                {siteSettings.pool_under_construction && (
                  <div className="p-4 bg-amber-50 border border-amber-200 rounded text-sm">
                    <p className="font-semibold text-amber-800 font-['Outfit'] mb-1">Aperçu de la notice :</p>
                    <p className="text-amber-700 font-['Outfit']">
                      ℹ️ <strong>Information :</strong> La piscine est actuellement en travaux et sera bientôt disponible.
                    </p>
                  </div>
                )}
              </div>
              
              <div className="mt-8 pt-6 border-t">
                <Button 
                  className="bg-[#C5A059] hover:bg-[#A6864A] text-white px-8"
                  onClick={saveSiteSettings}
                  disabled={savingSettings}
                  data-testid="save-settings-btn"
                >
                  {savingSettings ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Sauvegarde...
                    </>
                  ) : (
                    'Sauvegarder les paramètres'
                  )}
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Response Dialog */}
      <Dialog open={responseDialogOpen} onOpenChange={setResponseDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="font-['Playfair_Display']">Répondre à l'avis</DialogTitle>
          </DialogHeader>
          {selectedReview && (
            <div className="space-y-4">
              <div className="bg-gray-50 p-4 rounded">
                <p className="text-sm text-[#666] font-['Outfit'] italic">"{selectedReview.comment}"</p>
                <p className="text-xs text-[#999] mt-2">— {selectedReview.author}</p>
              </div>
              <div>
                <Label className="font-['Outfit']">Votre réponse</Label>
                <textarea 
                  value={responseText}
                  onChange={(e) => setResponseText(e.target.value)}
                  placeholder="Merci pour votre avis..."
                  className="w-full border border-[#E5E5E5] p-3 mt-1 font-['Outfit'] rounded min-h-[100px]"
                />
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setResponseDialogOpen(false)}>Annuler</Button>
            <Button 
              className="bg-[#C5A059] hover:bg-[#A6864A] text-white"
              onClick={handleRespondToReview}
            >
              Envoyer la réponse
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Promo Code Dialog */}
      <Dialog open={promoDialogOpen} onOpenChange={setPromoDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="font-['Playfair_Display']">Nouveau code promo</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label className="font-['Outfit']">Code</Label>
              <Input 
                value={newPromo.code}
                onChange={(e) => setNewPromo({...newPromo, code: e.target.value.toUpperCase()})}
                placeholder="WELCOME10"
                data-testid="promo-code-input"
              />
            </div>
            <div>
              <Label className="font-['Outfit']">Réduction (%)</Label>
              <Input 
                type="number"
                value={newPromo.discount_percent}
                onChange={(e) => setNewPromo({...newPromo, discount_percent: parseInt(e.target.value)})}
                min="1"
                max="100"
                data-testid="promo-discount-input"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="font-['Outfit']">Valide du</Label>
                <Input 
                  type="date"
                  value={newPromo.valid_from}
                  onChange={(e) => setNewPromo({...newPromo, valid_from: e.target.value})}
                  data-testid="promo-from-input"
                />
              </div>
              <div>
                <Label className="font-['Outfit']">Valide jusqu'au</Label>
                <Input 
                  type="date"
                  value={newPromo.valid_until}
                  onChange={(e) => setNewPromo({...newPromo, valid_until: e.target.value})}
                  data-testid="promo-until-input"
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setPromoDialogOpen(false)}>Annuler</Button>
            <Button 
              className="bg-[#C5A059] hover:bg-[#A6864A] text-white"
              onClick={handleCreatePromoCode}
              data-testid="create-promo-btn"
            >
              Créer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Media Dialog */}
      <Dialog open={mediaDialogOpen} onOpenChange={(open) => { setMediaDialogOpen(open); if (!open) resetMediaForm(); }}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="font-['Playfair_Display']">Ajouter une image</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            {/* Drag & Drop Zone */}
            <div
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
              onDrop={handleDrop}
              className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors cursor-pointer ${
                dragActive 
                  ? 'border-[#C5A059] bg-[#C5A059]/10' 
                  : 'border-[#E5E5E5] hover:border-[#C5A059]'
              }`}
              onClick={() => document.getElementById('file-upload').click()}
              data-testid="media-dropzone"
            >
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => e.target.files[0] && handleFileSelect(e.target.files[0])}
              />
              {previewUrl ? (
                <div className="relative">
                  <img 
                    src={previewUrl} 
                    alt="Preview" 
                    className="max-h-48 mx-auto rounded"
                  />
                  <button
                    onClick={(e) => { e.stopPropagation(); resetMediaForm(); }}
                    className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
                  >
                    <X className="w-4 h-4" />
                  </button>
                  <p className="text-sm text-[#666] mt-2 font-['Outfit']">{selectedFile?.name}</p>
                </div>
              ) : (
                <>
                  <Upload className="w-12 h-12 text-[#C5A059] mx-auto mb-4" />
                  <p className="text-[#666666] font-['Outfit']">
                    <span className="text-[#C5A059] font-semibold">Cliquez pour choisir</span> ou glissez-déposez
                  </p>
                  <p className="text-sm text-[#999] font-['Outfit'] mt-1">JPG, PNG, WEBP, GIF (max 10MB)</p>
                </>
              )}
            </div>

            <div>
              <Label className="font-['Outfit']">Description de l'image</Label>
              <Input 
                value={newMedia.alt}
                onChange={(e) => setNewMedia({...newMedia, alt: e.target.value})}
                placeholder="Ex: Chambre principale avec vue sur le jardin"
                data-testid="media-alt-input"
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="font-['Outfit']">Catégorie</Label>
                <select
                  value={newMedia.category}
                  onChange={(e) => setNewMedia({...newMedia, category: e.target.value})}
                  className="w-full border border-[#E5E5E5] p-2 mt-1 font-['Outfit'] rounded"
                  data-testid="media-category-select"
                >
                  <option value="villa">Villa</option>
                  <option value="bedroom">Chambre</option>
                  <option value="bathroom">Salle de bain</option>
                  <option value="exterior">Extérieur</option>
                  <option value="event">Événement</option>
                </select>
              </div>
              <div>
                <Label className="font-['Outfit']">Afficher dans</Label>
                <select
                  value={newMedia.section}
                  onChange={(e) => setNewMedia({...newMedia, section: e.target.value})}
                  className="w-full border border-[#E5E5E5] p-2 mt-1 font-['Outfit'] rounded"
                  data-testid="media-section-select"
                >
                  <option value="gallery">Galerie principale</option>
                  <option value="hero">Image Hero (page d'accueil)</option>
                  <option value="events">Section Événements</option>
                  <option value="booking">Page Réservation</option>
                </select>
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => { setMediaDialogOpen(false); resetMediaForm(); }}>Annuler</Button>
            <Button 
              className="bg-[#C5A059] hover:bg-[#A6864A] text-white"
              onClick={handleUploadMedia}
              disabled={uploadingMedia || !selectedFile}
              data-testid="upload-media-btn"
            >
              {uploadingMedia ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Upload en cours...
                </>
              ) : (
                <>
                  <Upload className="w-4 h-4 mr-2" />
                  Uploader
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AdminDashboard;
